import React, { useEffect, useMemo } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import BroadcastNotifications from './BroadcastNotifications'
import ChangePassword from './ChangePassword'
import CustomTabs from '../../components/Common/TabPanel'
import EsignAgreement from './EsignAgreement'
import Help from './Help'
import LocationText from './LocationText'
import ManagePolicy from './ManagePolicy'
import Profile from './Profile'
import TermsCondition from './TermsCondition'
import useLocalStorage from '../../hooks/useLocalStorage'
import { AdminRole } from '../../utils/config/auth-enums'
import { TabKeys, TabLabels } from '../../utils/config/user-enums'
import Path from '../../router/localRoutes'

const SettingComponent = () => {
  const [roleValue] = useLocalStorage('role')
  const [searchParams, setSearchParams] = useSearchParams()
  const role = roleValue
  const navigate = useNavigate()
  const filteredTabs = useMemo(() => {
    const tabData = [
      {
        key: TabKeys.PROFILE,
        content: <Profile />,
        roles: [AdminRole.GLOBAL_ADMIN, AdminRole.SUB_ADMIN],
      },
      {
        key: TabKeys.CHANGE_PASSWORD,
        content: <ChangePassword />,
        roles: [AdminRole.GLOBAL_ADMIN, AdminRole.SUB_ADMIN],
      },
      {
        key: TabKeys.HELP,
        content: <Help />,
        roles: [AdminRole.GLOBAL_ADMIN, AdminRole.SUB_ADMIN],
      },
      {
        key: TabKeys.PRIVACY_POLICY,
        content: <ManagePolicy />,
        roles: [AdminRole.GLOBAL_ADMIN],
      },
      {
        key: TabKeys.BROADCAST_NOTIFICATION,
        content: <BroadcastNotifications />,
        roles: [AdminRole.GLOBAL_ADMIN],
      },
      {
        key: TabKeys.LOCATION_TEXT,
        content: <LocationText />,
        roles: [AdminRole.GLOBAL_ADMIN],
      },
      {
        key: TabKeys.ESIGN_AGREEMENT,
        content: <EsignAgreement />,
        roles: [AdminRole.GLOBAL_ADMIN],
      },
      {
        key: TabKeys.TERMS_AND_CONDITIONS,
        content: <TermsCondition />,
        roles: [AdminRole.GLOBAL_ADMIN],
      },
    ]

    return tabData.filter((tab) => tab.roles.includes(role))
  }, [role])

  const currentTabIndex = useMemo(() => {
    const index = filteredTabs.findIndex(
      (tab) => searchParams.get('view') === tab.key,
    )
    return index !== -1 ? index : 0
  }, [filteredTabs, searchParams])

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSearchParams({ tab: 'setting', view: filteredTabs[newValue].key })
  }

  useEffect(() => {
    const viewParam = searchParams.get('view')
    const isValidView = filteredTabs.some((tab) => tab.key === viewParam)
    if (viewParam && !isValidView) {
      navigate(Path.NotFound)
    }
  }, [filteredTabs, navigate, searchParams])

  return (
    <div className="mt-[10px] w-full">
      <CustomTabs
        tabs={filteredTabs.map((tab) => ({
          label: TabLabels[tab.key],
          content: tab.content,
        }))}
        value={currentTabIndex}
        onChange={handleTabChange}
      />
    </div>
  )
}

export default SettingComponent
